/*
  lx1-testimonials.js — behaviour for the LX1 testimonials rail (snippets/lx1-beta-testimonials.liquid, styles in
  assets/lx1-testimonials.css). Loaded deferred; no dependencies.
  - Rail: scroll-snap track. Cards can differ in width (text 320, video 400), so the arrows and dots work from each
    card's own position rather than a fixed step: one dot per position a card can sit at the left edge, arrows move
    one card. Rebuilt on resize. Idempotent per rail; re-runs on theme-editor section reloads.
  - Video cards: the muted loop only loads and plays while the card is on screen (and never autoplays for visitors
    who ask for reduced motion — they see the poster). A click anywhere on the card (or its play button) opens one
    shared lightbox that plays the full video with sound; Esc, the backdrop and Close shut it and hand focus back to the button.
*/
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRail(sec) {
    var track = sec.querySelector('[data-lx1t-track]');
    if (!track || track.getAttribute('data-lx1t-init')) return;
    track.setAttribute('data-lx1t-init', '1');
    var dots = sec.querySelector('[data-lx1t-dots]');
    var prev = sec.querySelector('[data-lx1t-prev]');
    var next = sec.querySelector('[data-lx1t-next]');
    var cards = track.children;
    if (!cards.length) return;

    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    /* scroll offsets at which each card starts on the column edge, capped at the end of the rail and de-duplicated.
       A final stop less than half a card past the previous one replaces it (the rail just runs to its end), which
       keeps the dot count the same as the original fixed-step rail. */
    function stops() {
      var m = maxScroll(), base = cards[0].offsetLeft, out = [0];
      for (var i = 1; i < cards.length; i++) {
        var want = cards[i].offsetLeft - base, p = Math.min(m, want), last = out[out.length - 1];
        if (p - last <= 4) continue;
        if (p < want && out.length > 1 && p - last < (want - last) / 2) out[out.length - 1] = p; else out.push(p);
      }
      return out;
    }
    function current(s) {
      var x = track.scrollLeft, best = 0;
      for (var i = 1; i < s.length; i++) if (Math.abs(s[i] - x) < Math.abs(s[best] - x)) best = i;
      return best;
    }
    function buildDots() {
      if (!dots) return;
      var n = stops().length;
      dots.style.display = n < 2 ? 'none' : '';
      while (dots.children.length > n) dots.removeChild(dots.lastChild);
      while (dots.children.length < n) dots.appendChild(document.createElement('span'));
    }
    function update() {
      var idx = current(stops());
      if (dots) Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= maxScroll() - 4;
    }
    function go(dir) {
      var s = stops(), idx = Math.max(0, Math.min(s.length - 1, current(s) + dir));
      track.scrollTo({ left: s[idx], behavior: 'smooth' });
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    window.addEventListener('resize', function () { buildDots(); update(); }, { passive: true });
    buildDots();
    update();
  }

  /* ---- video card loops: load + play while visible, pause when scrolled away ---- */
  var io = null;
  function startLoop(v) {
    if (!v.getAttribute('src') && v.getAttribute('data-src')) v.setAttribute('src', v.getAttribute('data-src'));
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function initLoops(root) {
    if (reduceMotion) return;
    var vids = root.querySelectorAll('video[data-lx1t-loop]:not([data-lx1t-watched])');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(vids, startLoop); return; }
    io = io || new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) startLoop(e.target); else e.target.pause(); });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(vids, function (v) { v.setAttribute('data-lx1t-watched', '1'); io.observe(v); });
  }

  /* ---- lightbox ---- */
  var opener = null;
  function lightbox() { return document.querySelector('[data-lx1t-lb]'); }
  function openLightbox(btn) {
    var lb = lightbox(), src = btn.getAttribute('data-lx1t-full');
    if (!lb || !src) return;
    if (lb.parentNode !== document.body) document.body.appendChild(lb);
    var v = lb.querySelector('video');
    v.setAttribute('poster', btn.getAttribute('data-lx1t-poster') || '');
    v.setAttribute('aria-label', btn.getAttribute('aria-label') || '');
    v.src = src;
    opener = btn;
    lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    var c = lb.querySelector('[data-lx1t-lb-close]');
    if (c) { try { c.focus({ preventScroll: true }); } catch (err) { c.focus(); } }
  }
  function closeLightbox() {
    var lb = lightbox(); if (!lb || lb.hidden) return;
    var v = lb.querySelector('video');
    v.pause(); v.removeAttribute('src'); v.load();
    lb.hidden = true;
    document.documentElement.style.overflow = '';
    if (opener) { try { opener.focus({ preventScroll: true }); } catch (err) { opener.focus(); } }
    opener = null;
  }
  if (!window.__lx1tLightbox) {
    window.__lx1tLightbox = true;
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      // The whole video card opens the video, not just its play button (the button is still the keyboard control).
      var play = t.closest('[data-lx1t-play]');
      if (!play) { var card = t.closest('[data-lx1t-vcard]'); play = card && card.querySelector('[data-lx1t-play]'); }
      if (play) { e.preventDefault(); openLightbox(play); return; }
      if (t.closest('[data-lx1t-lb-close]')) { e.preventDefault(); closeLightbox(); return; }
      var lb = lightbox();
      if (lb && !lb.hidden && (t === lb || t.classList.contains('lx1t-lb__inner'))) closeLightbox();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lx1t]'), function (sec) { initRail(sec); initLoops(sec); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true }); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
